var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79616 0.935469C11.1558 0.13414 12.8434 0.134141 14.2031 0.93547L20.2633 4.50705C21.5871 5.28723 22.3996 6.70926 22.3996 8.24584V15.5448C22.3996 17.0814 21.5871 18.5034 20.2633 19.2836L14.2031 22.8552C12.8434 23.6565 11.1558 23.6565 9.79616 22.8552L3.73594 19.2836C2.41215 18.5034 1.59961 17.0814 1.59961 15.5448V8.24584C1.59961 6.70926 2.41215 5.28723 3.73594 4.50705L9.79616 0.935469ZM8.74409 6.43071C10.2623 6.43071 11.4931 7.66149 11.4931 9.17973V17.2861C9.97486 17.2861 8.74409 16.0553 8.74409 14.5371V6.43071ZM15.6167 14.1274C15.6167 12.6092 14.3859 11.3784 12.8677 11.3784V14.8325C12.8677 16.3507 14.0985 17.5815 15.6167 17.5815V14.1274Z",
    fill: "#D0D8E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltipIcon.62a17fce43b636b728c87083864effcd.svg";
export { ForwardRef as ReactComponent };